import {APP_INITIALIZER, inject, PLATFORM_ID} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {AppOrigin, QUERY_FROM_ORIGIN} from '../../shared/constants/url-params';
import {coerceValue} from '@kamp-n/ng-common-tools';

export const APP_THEME_INITIALIZER = {
	provide: APP_INITIALIZER,
	useFactory: () => {
		const document = inject(DOCUMENT);
		const platformId = inject(PLATFORM_ID);
		return () => {
			if(isPlatformBrowser(platformId)) {
				let origin: string | null = AppOrigin.KAMPN;
				try {
					origin = new URL(document.location.href).searchParams.get(QUERY_FROM_ORIGIN);
				} catch(e) {
					console.error('Failed to retrieve origin from params', e);
				}

				const theme = coerceValue(origin, Object.values(AppOrigin), AppOrigin.KAMPN);
				document.body.classList.add('theme-' + theme);
			}
		};
	},
	multi: true
};
